import {getConfig} from '@treatwell/tolgee';
import {TranslationObject} from '@treatwell/tolgee';

export const getFallbackLocaleLoader = () => {
  const config = getConfig();
  const languages = config.fallbackLanguages;

  const localeLoaderMap: Record<string, () => Promise<TranslationObject>> = {};
  for (const lang of languages) {
    localeLoaderMap[lang] = () =>
      import(
        /* webpackMode: "lazy" */
        /* webpackChunkName: "fallbackLocale-[request]" */
        `../../locales/${lang}.json`
      ).then((module) => {
        return module.default || module;
      });
  }
  return localeLoaderMap;
};
